import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    itemWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      '@media screen and (max-width: 425px)': {
        padding: Spacings.s10,
      },
    },
  },
  {
    name: 'template-carousel',
  },
);

export default useStyles;
